import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import API_BASE_URL from "../../config";
import Card from "../../Components/Card/Card";
import SEO from "../../Components/SEO/SEO.jsx";
import Loader from "../../Components/Loader/Loader";
import { categoriesService } from "../../Modules/Services/categories.service.ts";
import "./Category.css";
import { ChevronLeft } from "lucide-react";

function toNiceTitle(value) {
  const s = String(value || "").trim();
  if (!s) return "";
  const lowered = s.toLocaleLowerCase("ru-RU");
  return lowered
    .split(/\s+/g)
    .map((w) => (w ? w[0].toLocaleUpperCase("ru-RU") + w.slice(1) : ""))
    .join(" ");
}

const CategoryPage = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      setLoading(true);
      try {
        const res = await categoriesService.getCategoryProducts(categoryId);
        setData(res);
      } catch (e) {
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [categoryId]);

  const title = useMemo(() => {
    if (!data?.category_name) return "Категория";
    return toNiceTitle(data.category_name);
  }, [data]);

  if (loading) return <Loader />;

  if (!data) {
    return (
      <div className="Category--Container">
        <SEO title="Категория не найдена" />
        <div className="Category--Header">
          <button
            type="button"
            className="Category--Back"
            onClick={() => navigate("/")}
          >
            Назад
          </button>
        </div>
        <div className="Category--Empty">Категория не найдена</div>
      </div>
    );
  }

  return (
    <div className="Category--Container">
      <SEO title={title} />

      <div className="Category--Header">
        <button
          type="button"
          className="Category--Back"
          onClick={() => navigate("/")}
        >
          <ChevronLeft size={20} />
          Категории
        </button>
        <h1 className="Category--Title">{toNiceTitle(data.category_name)}</h1>
      </div>

      <div className="Category--Grid">
        {(data.products || []).map((product) => (
          <Card
            key={product.product_id}
            product={product}
            title={product.product_name}
            description={product.composition}
            variants={product.variants}
            image={`${API_BASE_URL}${product.image_url}`}
            compact
          />
        ))}
      </div>
    </div>
  );
};

export default CategoryPage;
